var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multipane-impl',{attrs:{"layout":_vm.layout},on:{"paneResizeStart":_vm.handleResizeStart,"paneResize":_vm.handleResize,"paneResizeStop":_vm.handleResizeStop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }